export default class UserValidator {
  static validateEmail(email) {
    let error = '';
    const re =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    error = '';
    if (!email) {
      error = "Email can't be blank";
    } else if (!re.test(email)) {
      error = 'Email is invalid';
    }
    return error;
  }

  static validateName(name) {
    let error = '';
    if (!name || /^ *$/.test(name)) {
      error = "Name can't be blank";
    }
    return error;
  }

  static validatePassword(password) {
    let error = '';
    if (!password) {
      error = "Password can't be blank";
    } else if (password.length < 8) {
      error = 'Password is too short (minimum 8 characters)';
    }
    return error;
  }

  static validatePasswordConfirmation(password, passwordConfirmation) {
    let error = '';
    if (password.length >= 8) {
      if (!passwordConfirmation) {
        error = "Password confirmation can't be blank";
      } else if (password !== passwordConfirmation) {
        error = "Password confirmation doesn't match password";
      }
    }
    return error;
  }
}
